export default {
  setUserInfo(state, payload) {
    state.givenName = payload.givenName;
    state.surname = payload.surname;
    state.organization = payload.organization;
  },
  setUpdateStatus(state, payload) {
    state.updateStatus = payload.status;
  }
}